<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Rendez-vous",
          icon: "bi bi-calendar2-week-fill",
          route: "appointments-index",
        },
        {
          label: "Nouveau RDV",
          icon: "bi bi-calendar-plus-fill",
          route: "appointments-create",
        },
      ],
    };
  },
};
</script>
